import { renderUserNameAndEmailRowCell } from '@modules/users/utils';
import { UserRoleColumnCell } from '@modules/workspaceSettings/components/Users/UserTableColumnCells/UserRoleColumnCell';
import { GridColDef } from '@mui/x-data-grid-pro';

export const getUsersColumns = (): GridColDef[] => {
  return [
    {
      field: 'name',
      headerName: 'Name',
      minWidth: 200,
      flex: 1,
      type: 'string',
      sortingOrder: ['asc', 'desc'],
      renderCell: renderUserNameAndEmailRowCell,
      display: 'flex',
    },
    {
      field: 'email',
      headerName: 'Email',
      minWidth: 200,
      flex: 1,
      type: 'string',
      sortingOrder: ['asc', 'desc'],
      renderCell: renderUserNameAndEmailRowCell,
      display: 'flex',
    },
    {
      field: 'role',
      headerName: 'Role',
      minWidth: 200,
      flex: 1,
      type: 'string',
      display: 'flex',
      sortingOrder: ['asc', 'desc'],
      renderCell: (params) => {
        return <UserRoleColumnCell params={params} />;
      },
    },
  ];
};
